import { render, staticRenderFns } from "./shippingFeeWaterReimbursementStatement.vue?vue&type=template&id=55b32eb8&scoped=true&"
import script from "./shippingFeeWaterReimbursementStatement.vue?vue&type=script&lang=js&"
export * from "./shippingFeeWaterReimbursementStatement.vue?vue&type=script&lang=js&"
import style0 from "./shippingFeeWaterReimbursementStatement.vue?vue&type=style&index=0&id=55b32eb8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b32eb8",
  null
  
)

export default component.exports